<div class="table-container">
<div class="hero-event-student-filter-row">
  <mat-form-field class="full-width-input">
    <input
      matInput
      placeholder="Search"
      [formControl]="searchControl" />
  </mat-form-field>
  <div class="add-button-box">
    <button
      mat-flat-button
      class="standard-button"
      color="primary"
      (click)="showBulkStudentProfileUploadModal.emit()">
      <fa-icon [icon]='["fas", "upload"]'></fa-icon>
      Import
    </button>
    <button
      type="submit"
      mat-flat-button
      class="standard-button"
      color="primary"
      (click)="showAddStudentModal.emit()">
      <fa-icon [icon]='["fas", "plus"]'></fa-icon>
      Student
    </button>
  </div>
</div>
<mat-table [dataSource]="filteredStudentList">
  <ng-container matColumnDef="{{ columns.STUDENT_ID }}">
    <mat-header-cell *matHeaderCellDef>
      {{ columns.STUDENT_ID }}
    </mat-header-cell>
    <mat-cell *matCellDef="let student">
      {{ student.studentExtId }}
    </mat-cell> </ng-container
  >
  <ng-container matColumnDef="{{ columns.STUDENT_NAME }}">
    <mat-header-cell *matHeaderCellDef>
      {{ columns.STUDENT_NAME }}
    </mat-header-cell>
    <mat-cell *matCellDef="let student">
      {{ student.firstName }} {{ student.lastName }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="{{ columns.GRADE }}">
  <mat-header-cell *matHeaderCellDef>
    {{ columns.GRADE }}
  </mat-header-cell>
  <mat-cell *matCellDef="let student">
    {{ student.grade }}
  </mat-cell>
</ng-container>
  <ng-container matColumnDef="{{ columns.ACTION }}">
    <mat-header-cell *matHeaderCellDef> Remove </mat-header-cell>
    <mat-cell *matCellDef="let student">
      <button
        type="submit"
        mat-flat-button
        class="secondary-button"
        (click)="removeStudent.emit(student.id)"
        options-id="ADD_STUDENT_TO_ROSTER">
        <fa-icon [icon]="['fas', 'minus']"></fa-icon>
      </button>
    </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let code; columns: displayedColumns"></mat-row>
</mat-table>
</div>
